import { Minesite } from './../index';

export class CompanyMinesites {
    public CompanyId: number;
    public Minesites: Minesite[] = [];
}
